import { render, staticRenderFns } from "./uusi-paakayttaja-form.vue?vue&type=template&id=6d0c1614&"
import script from "./uusi-paakayttaja-form.vue?vue&type=script&lang=ts&"
export * from "./uusi-paakayttaja-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports